import RequestManager from "./RequestManager";

const getSettings = async (settingsSetId, objectType, objectId) => {
    const settings = await RequestManager.get({
        url: `/settingsSet/v1/${settingsSetId}?${objectType}=${objectId}`
    });

    return settings
};

const removeTempIds = (body) => {
    const putBody = JSON.parse(JSON.stringify(body));

    putBody.insert.settingsGroups.forEach((settingGroup, i) => {
        if (settingGroup.identifier.includes('TEMP_ID')) {
            delete putBody.insert.settingsGroups[i].identifier;
        }
        settingGroup.settings.forEach((setting, j) => {
            if (setting._id.includes('TEMP_ID')) {
                delete putBody.insert.settingsGroups[i].settings[j]._id;
            }
        })
    });

    putBody.insert.customSettingTypes.forEach((customSettingType, i) => {
        if (customSettingType._id?.includes('TEMP_ID')) {
            delete putBody.insert.customSettingTypes[i]._id;
        }
        customSettingType.values.forEach((value, j) => {
            if (value._id?.includes('TEMP_ID')) {
                delete putBody.insert.customSettingTypes[i].values[j]._id;
            }
        })
    });

    return putBody;
};

const putSettings = async (settingsSetId, body, objectType, objectId) => {
    const putBody = removeTempIds(body);

    const putResponse = await RequestManager.put({
        url: `/settingsSet/v1/${settingsSetId}?${objectType}=${objectId}`,
        body: putBody
    });

    return putResponse
};

const migrateSettings = async (source, destination, type, sourceObjectId, destinationObjectId) => {
    const response = await RequestManager.put({
        url: `/settingsSet/migrate/v1/${source}/${destination}?objectType=${type}&sourceObjectId=${sourceObjectId}&destinationObjectId=${destinationObjectId}`,
    });

    return response;
};

const Setting = {
    getSettings,
    putSettings,
    migrateSettings
};

export default Setting;